import React, { LabelHTMLAttributes } from 'react';
import { cn } from '@/lib/utils'; // Assuming cn utility exists, usually does in shadcn/ui projects. If not, I'll remove it or create it.

// Helper for classes if cn doesn't exist, but checking lib/utils is good. 
// I'll check lib/utils exists. If I am not sure, I'll use simple string join or explicit class implementation.
// Backoffice seems to use simple classNames.

interface LabelProps extends LabelHTMLAttributes<HTMLLabelElement> { }

export const Label: React.FC<LabelProps> = ({ className, children, ...props }) => {
    return (
        <label
            className={`block text-sm font-medium text-gray-700 mb-2 ${className || ''}`}
            {...props}
        >
            {children}
        </label>
    );
};

export default Label;
